import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RecommendationCard } from "@/components/RecommendationCard";
import { TradeOffExplorer } from "@/components/TradeOffExplorer";
import { ChallengePanel } from "@/components/ChallengePanel";
import { SecondOpinionPanel } from "@/components/SecondOpinionPanel";
import { ShareDialog } from "@/components/ShareDialog";
import { Button } from "@/components/ui/button";
import { FileDown } from "lucide-react";

export function RecommendationStage({ d, id, onRefine, onChallenge, onSecondOpinion, busy }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl font-extrabold tracking-tight">
          {t("recommendation.heading")}
        </h2>
        <div className="flex items-center gap-2">
          <ShareDialog decisionId={id} title={d.title} buttonSize="sm" />
          <Link to={`/export/${id}`}>
            <Button variant="outline" size="sm" data-testid="export-btn">
              <FileDown className="mr-1.5 h-4 w-4" /> {t("recommendation.exportBrief")}
            </Button>
          </Link>
        </div>
      </div>

      <RecommendationCard recommendation={d.recommendation} trustChecks={d.trust_checks} />

      <TradeOffExplorer
        alternatives={d.alternatives}
        criteria={d.criteria}
        weights={d.weights}
        onRefine={onRefine}
        saving={busy === "refine"}
      />

      <div className="grid gap-6 xl:grid-cols-2">
        <ChallengePanel
          challenge={d.challenge}
          onRun={onChallenge}
          loading={busy === "challenge"}
        />
        <SecondOpinionPanel
          secondOpinion={d.second_opinion}
          recommendation={d.recommendation}
          onRun={onSecondOpinion}
          loading={busy === "second"}
        />
      </div>
    </div>
  );
}
